module.exports = __webpack_public_path__ + "img/Produktion PS1.240c0176.jpg";